





















































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Model,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import RatingInput from "@/components/misc/RatingInput.vue";
import { Action, Getter } from "vuex-class";
import { Country } from "@/shared/models/country";
import { LatLng, PropertyFormModel } from "./types";
import TimeInput from "./TimeInput.vue";
import LocationInput from "./LocationInput.vue";
import AddOnServicesTable from "./AddOnServicesTable.vue";
import EVisitorFacilitiesTable from "./EVisitorFacilitiesTable.vue";
import AmenitiesSelection from "./AmenitiesSelection.vue";
import DescriptionsTiles from "./DescriptionsTiles.vue";
import PoisTiles from "./PoisTiles.vue";
import Otas from "./Otas.vue";
import AccomodationUnitTypeTiles from "./AccomodationUnitTypeTiles.vue";
import PhotoEditor from "@/components/photo-editor/PhotoEditor.vue";
import { LanguageView } from "@/shared/models/languages";
import { CardType } from "@/shared/models/cardType";
import { PropertyType } from "@/shared/models/propertyType";
import { PricingModel } from "@/shared/models/pricingModel";
import { FinancialSettingsType } from "@/store/modules/financial";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import { OwnerPricingModel } from "@/shared/models/ownerPricingModel";
import PropertyOwner from "./PropertyOwner.vue";
import _ from "lodash";
import {
  AgencyWorkModel,
  AgencyWorkModelsEnum,
} from "@/shared/models/agencyWorkModel";
import { VATCategoryForPrepayments } from "@/shared/models/vatCategoryForPrepayments";
import { BusinessUnit } from "@/shared/models/businessUnit";
import DateField from "@/components/misc/DateField.vue";
import {
  CategoriesEnum,
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
  OwnerContractExportType,
  OwnerPricingModelEnum,
} from "@/shared/models/enums.type";
import { DateTime } from "luxon";
import OfficialRatesExportForOwners from "@/components/property/official-rates/OfficialRatesExportForOwners.vue";
import { Currency } from "@/shared/models/currency";
import { PriceCalculationMethodView } from "@/shared/models/priceCalculationMethods";
import {
  AgencyFeesPropertyModel,
  AgencyFeesPropertyRequest,
} from "@/shared/models/agencyFee";
import FormDescription from "@/components/misc/FormDescription.vue";
import PropertyFormAgencyFeeSelection from "./PropertyFormAgencyFeeSelection.vue";
import { Notification } from "@/store/modules/notifications";
import { ListModel } from "@/shared/models/listModel";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";

@Component({
  components: {
    RatingInput,
    TimeInput,
    LocationInput,
    AddOnServicesTable,
    EVisitorFacilitiesTable,
    AmenitiesSelection,
    DescriptionsTiles,
    PoisTiles,
    AccomodationUnitTypeTiles,
    PhotoEditor,
    Otas,
    NumericInputImproved,
    RequireRole,
    PropertyOwner,
    DateField,
    OfficialRatesExportForOwners,
    FormDescription,
    PropertyFormAgencyFeeSelection,
  },
})
export default class PropertyForm extends Vue {
  @Model() model!: PropertyFormModel;
  @PropSync("tab") internalTab?: string;
  @PropSync("disable") internalDisable?: boolean;
  @PropSync("add") internalAdd?: boolean;

  current = new PropertyFormModel();
  original = new PropertyFormModel();
  useLocationAsKeyPickup = false;
  originalKeyPickup = false;
  generateOwnerContractOpen = false;
  exportOfficialRatesForOwnerOpen = false;
  addAgencyFeesOpen = false;
  selectedAgencyFees = [] as AgencyFeesPropertyModel[];
  agencyFeePriceManuallyChanged = false;

  officialRatesYear = DateTime.now().year;
  years = _.range(DateTime.now().year + 4, 2018, -1);

  @Watch("model", { immediate: true })
  modelChanged(fresh: PropertyFormModel) {
    this.useLocationAsKeyPickup =
      fresh.postalCodeId === fresh.keyPickupLocationPostalCodeId &&
      fresh.cityId === fresh.keyPickupLocationCityId &&
      fresh.streetName === fresh.keyPickupLocationStreetName &&
      fresh.houseNumber === fresh.keyPickupLocationHouseNumber &&
      fresh.longitude === fresh.keyPickupLocationLongitude &&
      fresh.latitude === fresh.keyPickupLocationLatitude;
    this.originalKeyPickup = _.cloneDeep(this.useLocationAsKeyPickup);
    this.current = _.cloneDeep(fresh);
    this.original = _.cloneDeep(fresh);
    this.selectedAgencyFees = this.current.agencyFeesProperty;
  }
  @Watch("property", { deep: true })
  propertyChanged() {
    this.$emit("input", this.property);
  }

  get property() {
    return this.current;
  }

  @Watch("property.agencyWorkModelId")
  ownNameElseAccount(workModel: AgencyWorkModelsEnum | string) {
    if (
      workModel === this.agencyWorkModelsEnum.OwnNameAndOtherInvoice &&
      this.vatCategoriesForPrepayments?.length === 1
    ) {
      this.property.vatCategoryForPrepaymentsId =
        this.property.vatCategoryForPrepaymentsId ??
        this.vatCategoriesForPrepayments[0].id;
    }
  }

  @Watch("property.ownerPricingModelId")
  relativePricing(workModel: OwnerPricingModelEnum | string) {
    if (workModel === this.ownerPricingModelEnum.Relative) {
      this.property.ownerPayoutPercent =
        this.property.ownerPayoutPercent ?? null;
    }
  }

  propertyOwnerFormActive = false;
  propertyManagerFormActive = false;

  get rules() {
    return {
      mustBeZeroOrPositive: (value: number) => {
        return value >= 0 || this.$t("Validation.MustBeZeroOrPositive");
      },
    };
  }

  @Ref("rootForm") rootForm?: { validate: () => boolean; inputs: any[] };
  @Ref("ownerFormRef") ownerFormRef?: { validate: () => boolean };

  async created() {
    // #region codebooks
    const promises = [];

    if ((this.countries?.length ?? 0) === 0 && this.refreshCountries) {
      promises.push(this.refreshCountries());
    }
    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      promises.push(this.refreshLanguages());
    }
    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }
    if ((this.propertyTypes?.length ?? 0) === 0 && this.refreshPropertyTypes) {
      promises.push(this.refreshPropertyTypes());
    }
    if ((this.pricingModels?.length ?? 0) === 0 && this.refreshPricingModels) {
      promises.push(this.refreshPricingModels());
    }
    if (
      (this.ownerPricingModels?.length ?? 0) === 0 &&
      this.refreshOwnerPricingModels
    ) {
      promises.push(this.refreshOwnerPricingModels());
    }
    if (!this.storedSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }
    if (
      (this.agencyWorkModels?.length ?? 0) === 0 &&
      this.refreshAgencyWorkModels
    ) {
      promises.push(this.refreshAgencyWorkModels());
    }
    if (
      (this.vatCategoriesForPrepayments?.length ?? 0) === 0 &&
      this.refreshVATCategoriesForPrepayments
    ) {
      promises.push(this.refreshVATCategoriesForPrepayments());
    }
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }

    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 &&
      this.refreshPriceCalculationMethods
    ) {
      promises.push(this.refreshPriceCalculationMethods());
    }

    await Promise.all(promises);
    // #endregion
  }

  // #region codebooks
  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") countries?: Country[];

  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];

  @Action("codebooks/refreshCardTypes") refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  @Action("codebooks/refreshPropertyTypes")
  refreshPropertyTypes?: () => Promise<void>;
  @Getter("codebooks/propertyTypes") propertyTypes?: PropertyType[];

  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];
  // prettier-ignore
  @Action("codebooks/refreshPriceCalculationMethods") refreshPriceCalculationMethods?: () => Promise<void>;
  // prettier-ignore
  @Getter("codebooks/priceCalculationMethods") priceCalculationMethods?: PriceCalculationMethodView[];

  get sortedPropertyTypes() {
    const tempPropertyTypes = [...(this.propertyTypes ?? [])];
    return tempPropertyTypes
      .map((x) => {
        return {
          value: x.id,
          name: this.$t(x.textResourceKey),
        };
      })
      .sort((a, b) => (a.name > b.name ? 1 : -1));
  }

  @Action("codebooks/refreshPricingModels")
  refreshPricingModels?: () => Promise<void>;
  @Getter("codebooks/pricingModels") pricingModels?: PricingModel[];

  @Action("codebooks/refreshOwnerPricingModels")
  refreshOwnerPricingModels?: () => Promise<void>;
  @Getter("codebooks/ownerPricingModels")
  ownerPricingModels?: OwnerPricingModel[];

  @Action("codebooks/refreshAgencyWorkModels")
  refreshAgencyWorkModels?: () => Promise<void>;
  @Getter("codebooks/agencyWorkModels") agencyWorkModels?: AgencyWorkModel[];
  agencyWorkModelsEnum = AgencyWorkModelsEnum;
  ownerPricingModelEnum = OwnerPricingModelEnum;

  get internalAgencyWorkModels() {
    return (
      this.agencyWorkModels?.map((x) => {
        return {
          ...x,
          disabled:
            !this.property.ownerId &&
            x.id != AgencyWorkModelsEnum.OwnNameAndOwnInvoice,
        };
      }) ?? []
    );
  }

  @Action("codebooks/refreshVATCategoriesForPrepayments")
  refreshVATCategoriesForPrepayments?: () => Promise<void>;
  @Getter("codebooks/vatCategoriesForPrepayments")
  vatCategoriesForPrepayments?: VATCategoryForPrepayments[];

  // prettier-ignore
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  // #endregion

  @Getter("appParams/showOwnerPriceOffset") showOwnerPriceOffset?: boolean;
  @Getter("appParams/tenantUsesPropertiesAsBusinessUnits")
  tenantUsesPropertiesAsBusinessUnits?: boolean;
  @Getter("appParams/typeId") tenantTypeId?: number;
  @Getter("appParams/tenantHasAgencyCommissionForPrepayments")
  tenantHasAgencyCommissionForPrepayments?: boolean;

  @Getter("businessUnit/availableBusinessUnits")
  availableBusinessUnits?: BusinessUnit[];

  @Getter("appParams/tenantUsesOfficialRates")
  tenantUsesOfficialRates?: boolean;
  @Getter("appParams/tenantUsesInputPrice")
  tenantUsesInputPrice?: boolean;
  @Getter("appParams/tenantUsesAgencyFees")
  tenantUsesAgencyFees?: boolean;

  center = { lat: 20, lng: 0 } as LatLng;
  zoom = 1;

  form = false;
  ownerForm = true;
  loading = false;

  ownerContractExportTypes = [
    {
      value: OwnerContractExportType.Resident,
      text: "t.OwnerContractExportType.Resident",
    },
    {
      value: OwnerContractExportType.NonResident,
      text: "t.OwnerContractExportType.NonResident",
    },
    {
      value: OwnerContractExportType.LegalEntity,
      text: "t.OwnerContractExportType.LegalEntity",
    },
  ];

  agencyFeeheaders = [
    {
      text: "AgencyFee.Name",
      value: "name",
    },
    {
      text: "AgencyFee.Price",
      value: "price",
    },
    {
      text: "AgencyFee.CalculationMethod",
      value: "calculationMethodId",
    },
    {
      text: "Actions",
      value: "actions",
    },
  ];

  get agencyFees() {
    return this.property.agencyFeesProperty;
  }

  get translatedAgencyFeeHeaders() {
    return this.agencyFeeheaders.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  ownerContractExportType = null;

  get disableOfficialRatesButton() {
    return !this.officialRatesYear || this.internalDisable;
  }

  submit() {
    const formValid = this.rootForm?.validate();
    const ownerFormValid = this.ownerFormRef
      ? this.ownerFormRef.validate()
      : true;

    if (!formValid || !ownerFormValid) {
      const invalidInputs = this.rootForm?.inputs.filter((x) => !x.valid) ?? [];
      if (invalidInputs.length > 0) {
        invalidInputs[0].$el.scrollIntoView({ behavior: "smooth" });
      }
      return;
    }

    this.internalDisable = true;

    if (this.form) {
      if (this.useLocationAsKeyPickup) {
        this.property.keyPickupLocationPostalCodeId =
          this.property.postalCodeId;
        this.property.keyPickupLocationCityId = this.property.cityId;
        this.property.keyPickupLocationStreetName = this.property.streetName;
        this.property.keyPickupLocationHouseNumber = this.property.houseNumber;
        this.property.keyPickupLocation = this.property.location;
      }

      this.property.agencyFeesProperty = this.selectedAgencyFees;

      const model = { ...this.property };

      if (this.property.acceptsOnlyCash) {
        model.cardTypeIds = [];
      }

      if (this.agencyFeePriceManuallyChanged) {
        this.popupForReservationUpdate(model, false);
      } else {
        this.$emit("submit", model);
      }
    }
  }

  fullSyncLoading = false;
  fullSync() {
    if (!this.model.id) {
      return;
    }

    this.fullSyncLoading = true;
    this.axios
      .post(`/properties/${this.model.id}/otas/fullsync`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Property.FullSyncTriggered"),
          timeout: 5000,
        });
      })
      .catch(() => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("Property.FullSyncError"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.fullSyncLoading = false;
      });
  }

  async submitOwnerContractGeneration() {
    this.property.categorizationDate =
      this.property.categorizationDate?.toString() === ""
        ? undefined
        : this.property.categorizationDate;
    if (this.form) {
      const model = { ...this.property };
      this.$emit("submit", model, this.ownerContractExportType);
    }
  }

  get showPropertyPaysVat() {
    return this.storedSettings?.paysVat ?? true;
  }

  getCurrencyCode(currencyId: number) {
    return this.currencies?.find((x) => x.id == currencyId)?.isoCode;
  }

  getPriceCalculationMethodText(priceCalculationMethodId: number) {
    return this.$t(
      this.priceCalculationMethods?.find(
        (x) => x.id == priceCalculationMethodId
      )?.textResourceKey || ""
    );
  }

  @Getter("language/language") language?: string;

  get cultureCode() {
    return this.language ?? "hr-HR";
  }

  async loadAgencyFees() {
    this.loading = true;

    await this.axios
      .get<ListModel<AgencyFeesPropertyModel>>(
        "/AgencyFees/GetAgencyFeesOnProperty",
        {
          params: {
            propertyId: this.property.id,
            cultureCode: this.cultureCode,
          },
        }
      )
      .then((res) => {
        // We put it in 'original' as well to avoid the pending changes warning message that pops up because these changes are already saved.
        this.original.agencyFeesProperty = res.data.result;
        this.property.agencyFeesProperty = res.data.result;
        this.selectedAgencyFees = res.data.result;
      })
      .finally(() => (this.loading = false));
  }

  deleteAgencyFee(item: AgencyFeesPropertyModel) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${item?.name}'?`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.popupForReservationUpdate(item, true);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  async deleteAgencyFeeConfirm(
    item: AgencyFeesPropertyModel,
    updateReservations: boolean
  ) {
    await Vue.axios
      .delete(`/AgencyFees/DeleteAgencyFeeProperty/${item.id}`, {
        data: {
          id: item.id,
          propertyId: item.propertyId,
          agencyFeeId: item.agencyFeeId,
          updateReservations: updateReservations,
        },
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("AgencyFee.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.loadAgencyFees();
      });
  }

  removeWorkModelAndCategorizationInfo() {
    this.property.categorizationClass = null;
    this.property.categorizationNumber = null;
    this.property.categorizationDate = undefined;
    this.property.agencyWorkModelId = null;
  }

  checkForChanges() {
    return (
      _.isEqual(this.property, this.original) &&
      _.isEqual(this.useLocationAsKeyPickup, this.originalKeyPickup)
    );
  }

  resetFormModel() {
    this.original = _.cloneDeep(this.property);
    this.originalKeyPickup = _.cloneDeep(this.useLocationAsKeyPickup);
  }

  close() {
    this.$router.back();
  }

  required(v: any) {
    return v ? true : this.$t("Validation.Required").toString();
  }

  requiredWith0Allowed(value: any) {
    return !!value || value === 0
      ? true
      : this.$t("Validation.Required").toString();
  }

  maxLength(max: number) {
    return (v: string) =>
      v.length <= max ? true : this.$t("Validation.MaxLength", { count: max });
  }

  mustBePositive(value: any) {
    return (!!value || value === 0) && value >= 0
      ? true
      : this.$t("Validation.MustBePositive").toString();
  }

  mustBePositiveEmptyOrZero(value: any) {
    return !value || value === 0 || value > 0
      ? true
      : this.$t("Validation.MustBePositive").toString();
  }

  maxValue(max: number) {
    return (v: any) =>
      v <= max ? true : this.$t("Validation.MaxValue", { max: max });
  }

  wholeNumbersOnly(value: number) {
    return (
      value == null ||
      value == undefined ||
      value % 1 == 0 ||
      this.$t("Validation.MustBeWholeNumber")
    );
  }

  get cutOffDaysHasValue() {
    return !!this.property.cutOffDays || this.property.cutOffDays === 0;
  }

  get category() {
    if (this.property.categoryId === CategoriesEnum.Empty) {
      return 0;
    }
    return this.property.categoryId + 1;
  }
  set category(val: number) {
    if (
      val === 0 ||
      (val === 1 && this.property.categoryId === CategoriesEnum.Star2)
    ) {
      this.property.categoryId = CategoriesEnum.Empty;
    } else {
      this.property.categoryId = val - 1;
      if (val === 1) {
        this.$nextTick(() => {
          this.property.categoryId = CategoriesEnum.Star2;
        });
      }
    }
  }

  async addAgencyFee(agencyFees: AgencyFeesPropertyRequest) {
    this.loading = true;
    await Vue.axios
      .post("/AgencyFees/CreateAgencyFeesProperty", agencyFees)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("AgencyFee.SaveSuccess"),
          timeout: 5000,
        });

        this.addAgencyFeesOpen = false;
        this.loadAgencyFees();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  popupForReservationUpdate(item: any, isAgencyFeeDeletion: boolean) {
    if (isAgencyFeeDeletion === true) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("PropertyAgencyFee.ApplyToFutureReservations"),
        actions: [
          {
            text: this.$t("Yes"),
            fun: () => {
              this.deleteAgencyFeeConfirm(item, true);
              return true;
            },
          },
          {
            text: this.$t("No"),
            fun: () => {
              this.deleteAgencyFeeConfirm(item, false);
              return true;
            },
          },
        ],
        timeout: 30000,
      } as Notification);
    } else {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("PropertyAgencyFee.ApplyToFutureReservations"),
        actions: [
          {
            text: this.$t("Yes"),
            fun: () => {
              item.updateReservations = true;
              this.agencyFeePriceManuallyChanged = false;
              this.$emit("submit", item);
              return true;
            },
          },
          {
            text: this.$t("No"),
            fun: () => {
              item.updateReservations = false;
              this.agencyFeePriceManuallyChanged = false;
              this.$emit("submit", item);
              return true;
            },
          },
        ],
        timeout: 30000,
      } as Notification);
    }
  }

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }
  get showEvisitor() {
    return this.eVisitorIntegration?.id !== EVisitorIntegrationEnum.None;
  }
}
